import dayjs from 'dayjs'
import { UserRes } from '@/types/api'
import { getToken } from './checkLogin'

class UserInfoCache {
  CACHE_KEY = '__user_info_cache__'

  get token() {
    return getToken()
  }

  resetCache() {
    localStorage.removeItem(this.CACHE_KEY)
  }

  getCache() {
    const str = localStorage.getItem(this.CACHE_KEY)

    if (!str) {
      return null
    }

    const fn = this.generateCache
    const cache = JSON.parse(str) as ReturnType<typeof fn>

    // 当前用户 token 与缓存时的 token 不一致，视为缓存失效
    // 取出来的缓存时间戳超过一定时长，视为缓存失效
    if (cache.token !== this.token || dayjs.unix(cache.timeStamp).isBefore(dayjs().subtract(3, 'hours'))) {
      this.resetCache()
      return null
    }

    return cache.userInfo
  }

  setCache(userInfo: UserRes) {
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(this.generateCache(userInfo)))
  }

  generateCache(userInfo: UserRes) {
    return {
      timeStamp: dayjs().unix(),
      token: this.token,
      userInfo
    }
  }
}

export default new UserInfoCache()
